import { correctNode } from './correctFocus';
export var pickFirstFocus = function (nodes) {
    if (nodes[0] && nodes.length > 1) {
        return correctNode(nodes[0], nodes);
    }
    return nodes[0];
};
export var pickFocusable = function (nodes, index) {
    if (nodes.length > 1) {
        return nodes.indexOf(correctNode(nodes[index], nodes));
    }
    return index;
};



//////////////////
// WEBPACK FOOTER
// ./~/focus-lock/dist/es2015/utils/firstFocus.js
// module id = 1146
// module chunks = 2